export default {
    1: {
        'flattened': {
            mode: 'flatten',
            restoreInRoot: true
        },
        'tasks': {
            mode: 'list',
            createOptions: { keyPath: 'id' }
        },
        'files': {
            mode: 'list',
            createOptions: { keyPath: 'id' }
        },
        'jobs': {
            mode: 'list',
            createOptions: { keyPath: 'id' },
            indexes: {
                'type': {},
                'status': {},
                'status.type': {
                    keyPath: ['status', 'type']
                },
                'hasDateToday': {},
                'hasDateToday.status': {
                    keyPath: ['hasDateToday', 'status']
                },
                'months': {
                    keyPath: 'month'
                }
            }
        }
    },
    2: {
        'flattened': {
            mode: 'flatten',
            restoreInRoot: true
        },
        'tasks': {
            mode: 'list',
            createOptions: { keyPath: 'id' }
        },
        'files': {
            mode: 'list',
            createOptions: { keyPath: 'id' }
        },
        'jobs': {
            mode: 'list',
            restore: false,
            createOptions: { keyPath: 'id' },
            indexes: {
                'type': {},
                'status': {},
                'status.type': {
                    keyPath: ['status', 'type']
                },
                'hasDateToday': {},
                'hasDateToday.status': {
                    keyPath: ['hasDateToday', 'status']
                },
                'months': {
                    keyPath: 'month'
                }
            }
        },
        'jobsOverride': {
            module: 'jobs',
            mode: 'list',
            createOptions: { keyPath: 'id' }
        }
    }
}